// extracted by mini-css-extract-plugin
module.exports = {"Content":"SliderContent_Content__3l8vx","firstTitle":"SliderContent_firstTitle__1hNN2","secondTitle":"SliderContent_secondTitle__34DnG","para":"SliderContent_para__2YLYy"};